/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';

import { ThemeComponent } from '@types';

import { colors } from '../foundations';
import { getColorSchemeOrDefault } from '../utils/variants';

export type TextareaSizes = 'sm' | 'md' | 'lg' | string;
export type TextareaVariants = 'default';

export const Textarea: ThemeComponent<TextareaSizes, TextareaVariants, ChakraTextareaProps> = {
  baseStyle: () => ({
    width: '100%',
    minHeight: '5rem',
    fontFamily: 'body',
    transitionDuration: '0.1s',
    outline: 'none',
  }),

  sizes: {
    sm: {
      fontSize: 'sm',
      lineHeight: 'sm',
    },
    md: {
      fontSize: 'md',
      lineHeight: 'md',
    },
    lg: {
      fontSize: 'lg',
      lineHeight: 'lg',
    },
  },

  variants: {
    default: ({ colorScheme }) => {
      const colorSchemaDefault = getColorSchemeOrDefault({
        colorScheme,
        colorSchemeDefault: 'ui',
      });

      return {
        border: 'sm',
        borderRadius: 'xs',
        padding: 'md',
        color: `${colorSchemaDefault}.700`,
        borderColor: `${colorSchemaDefault}.200`,
        _placeholder: {
          color: `${colorSchemaDefault}.500`,
        },
        _hover: {
          borderColor: `${colorSchemaDefault}.500`,
        },
        _focus: {
          border: 'md',
          borderColor: 'primary.500',
          boxShadow: `0px 0px 0px 3px ${colors.primary[100]}`,
        },
        _disabled: {
          cursor: 'not-allowed',
          background: 'ui.50',
          borderColor: `${colorSchemaDefault}.200`,
        },
        _invalid: {
          borderColor: 'supportA.600',
          _focus: {
            boxShadow: `0px 0px 0px 3px ${colors.supportA[100]}`,
          },
        },
      };
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'default',
    colorScheme: null,
  },
};
